export default __webpack_public_path__ + "static/media/Coin Icon.d3eb26bb.svg";